import React, { useState } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { Button } from 'gatsby-theme-material-ui';
import Section from '../../../shared/Section/Section';
import SwiperComponent from '../../../shared/SwiperComponent/SwiperComponent';
import StructureElement from '../../../shared/StructureElement/StructureElement';
import VerticalSliderComponent from '../../../shared/VerticalSliderComponent/VerticalSliderComponent';
import ModalBlock from '../../../shared/ModalBlock/ModalBlock';
import DetailedProgramModal from '../../../shared/Modals/DetailedProgramModal';
import { styles } from './styles';
import { AiCard } from './AiCard';
import PartTimeInfoCard from './PartTimeInfoCard';

function Structure({
  title,
  subtitle,
  minHeight,
  minWidth,
  list,
  ymEvents = {},
  myTargetEvents = {},
  leadData,
  bg,
  programImgs,
  program,
  hideAiCard = false,
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Section
      anchor="program"
      bg={bg}
      withoutBg={!bg || (isSm && program === 'ds')}
      title={!isSm && title}
      subtitle={!isSm && subtitle}
      titleSx={(theme) => ({
        [theme.breakpoints.down('sm')]: { position: 'sticky', top: 140 },
      })}
      partTimeInfo={!isSm && program === 'jsPartTime'}
    >
      {isSm ? (
        <VerticalSliderComponent
          slides={[
            () => (
              <Box>
                {subtitle && (
                  <Typography variant="desktopH5">{`<${subtitle}>`}</Typography>
                )}
                {title && (
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      gap: '16px',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography
                      variant="desktopH2"
                      sx={{ color: 'kit.text.main' }}
                    >
                      {Array.isArray(title)
                        ? title.map((item) => (
                            <Typography key={item}>{item}</Typography>
                          ))
                        : title}
                    </Typography>
                    {program === 'jsPartTime' && <PartTimeInfoCard />}
                  </Box>
                )}
              </Box>
            ),
            ...(hideAiCard ? [] : [() => <AiCard program={program} />]),
            ...list.map(
              (item, index, list) =>
                function () {
                  return (
                    <StructureElement
                      {...item}
                      image={programImgs['program/codeTitle']}
                      lastItem={index === list.length - 1}
                      isCareerCenter
                    />
                  );
                },
            ),
          ]}
          marginTops={[...list.map((item) => item.marginTop)]}
          hasAiCard={program !== 'jsPartTime'}
        />
      ) : (
        <SwiperComponent
          shiftNavigate
          slidesPerView={1.5}
          spaceBetween={8}
          breakpoints={{
            600: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            750: {
              slidesPerView: 2.5,
              spaceBetween: 16,
            },
            900: {
              slidesPerView: 3.2,
              spaceBetween: 18,
            },

            1200: {
              slidesPerView: 4.06,
              spaceBetween: 12,
            },
          }}
          slides={[
            ...(hideAiCard ? [] : [() => <AiCard program={program} />]),
            ...list.map(
              (item, index, list) =>
                function () {
                  return (
                    <StructureElement
                      {...item}
                      image={programImgs['program/codeTitle']}
                      height={minHeight}
                      width={minWidth}
                      lastItem={index === list.length - 1}
                      isCareerCenter
                    />
                  );
                },
            ),
          ]}
        />
      )}
      {leadData && (
        <Box sx={styles.buttonWrapper}>
          <Button
            variant="kitPrimary"
            size="large"
            onClick={() => setIsOpen(true)}
          >
            Получить подробную программу
          </Button>
        </Box>
      )}
      <ModalBlock isOpen={isOpen} handleClose={() => setIsOpen(false)}>
        <DetailedProgramModal
          extraLeadData={{ ...leadData }}
          ymSubmitEventType={ymEvents.programFormSubmit}
          myTargetEvent={myTargetEvents.programFormSubmit}
        />
      </ModalBlock>
    </Section>
  );
}

export default Structure;
